/**
 * The Individual row for line items on the bill credit detail view
 */
import React from 'react';
import moment from 'moment';
import numeral from 'numeral';
import PropTypes from 'prop-types';
import TableCell from '../ReusableComponents/Table/TableCell';
import TableRow from '../ReusableComponents/Table/TableRow';

function CreditRow({ credit }) {
  return (
    <TableRow>
      <TableCell size="small" scope="row" align="center">
        {moment(credit.date, 'YYYY-MM-DD').format('MM/DD/YYYY')}
      </TableCell>
      <TableCell size="medium" align="center">
        {credit.credit_reference_number}
      </TableCell>
      <TableCell align="left">{credit.description}</TableCell>
      <TableCell align="center">{credit.applied_to}</TableCell>
      <TableCell align="right">
        {numeral(credit.amount).format('$0,0.00')}
      </TableCell>
    </TableRow>
  );
}

CreditRow.propTypes = {
  credit: PropTypes.shape({
    date: PropTypes.string,
    reference_number: PropTypes.string,
    applied_to: PropTypes.string,
    amount_due: PropTypes.number,
    amount: PropTypes.number,
    description: PropTypes.string,
  }).isRequired,
};

export default CreditRow;
